import React, { useEffect } from 'react';
import classNames from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import LightbulbOutline from 'mdi-react/LightbulbOutlineIcon';

import { useModal } from 'modules/shared/hooks';
import EditFlight from 'modules/shared/FlightDetails/components/EditFlight';
import { IconName } from 'modules/shared/FlightDetails/components/EditFlight/EditFlight';

type Props = {
  loading: boolean;
  errorMsg: string;
  btnIcon: IconName;
  isField: string;
  isLoadingField: string;
  disabled: boolean;
  onClick: any;
  clearState?: any;
  mode?: 'kiosk' | 'main';
  className?: string;
};

const GroupBtnLight: React.FC<Props> = ({
  loading,
  isField,
  isLoadingField,
  btnIcon,
  disabled,
  onClick,
  errorMsg,
  mode = 'main',
  className = '',
}) => {
  const { isShow, openModal: showIcon, closeModal: hideIcon } = useModal();

  useEffect(() => {
    if (isField === isLoadingField && !loading) {
      showIcon();
    } else {
      hideIcon();
    }
  }, [loading, isLoadingField]);

  return (
    <div className="d-flex flex-row align-items-center ml-02 position-relative">
      {loading ? (
        <div className="w-h-26">
          <EditFlight className={className} icon="loading" mode={mode} disabled />
        </div>
      ) : (
        <EditFlight
          className={className}
          icon={btnIcon}
          mode={mode}
          disabled={disabled}
          {...(onClick && { clickHandler: onClick })}
        />
      )}

      {isShow && (
        <div className={mode === 'main' ? 'phoneLight' : 'phoneLightKiosk'}>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="button-tooltip-2">{errorMsg.length ? errorMsg : 'Успішно'}</Tooltip>}
          >
            <LightbulbOutline
              className={classNames('ml-2 check-phone', errorMsg.length ? 'text-danger' : 'text-success')}
              size="18"
            />
          </OverlayTrigger>
        </div>
      )}
    </div>
  );
};

export default GroupBtnLight;
